import { Box, Typography } from '@mui/material';

export default function CardTextItem({
  label,
  description,
  variant = 'caption',
  disabled = false,
}) {
  return (
    <Box>
      <Typography
        variant="body2"
        component="p"
        color="secondary"
        fontWeight={600}
      >
        {label}
      </Typography>
      <Typography
        variant={variant}
        fontWeight={500}
        component="p"
        color={disabled ? 'secondary' : 'inherit'}
        sx={{ wordBreak: 'break-word', textTransform: 'capitalize' }}
      >
        {description || '-'}
      </Typography>
    </Box>
  );
}
